import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { createHtmlRenderState } from '../../html/utils/create-render-state.mjs';
var createSvgRenderState = function createSvgRenderState() {
  return _objectSpread(_objectSpread({}, createHtmlRenderState()), {}, {
    attrs: {}
  });
};
export { createSvgRenderState };